var map = {
	"./20481472_cinematic-parallax-slideshow_by_cowardrobertford_preview_1576243035263.mp4": "./src/assets/images/stockassets/20481472_cinematic-parallax-slideshow_by_cowardrobertford_preview_1576243035263.mp4",
	"./Add Droplist_1576243035263.mp4": "./src/assets/images/stockassets/Add Droplist_1576243035263.mp4",
	"./Customer Side Update -1_1576243035263.mp4": "./src/assets/images/stockassets/Customer Side Update -1_1576243035263.mp4",
	"./Minor Changes_1576214653535.mp4": "./src/assets/images/stockassets/Minor Changes_1576214653535.mp4",
	"./Project Board Feedback_1576144014933.mp4": "./src/assets/images/stockassets/Project Board Feedback_1576144014933.mp4",
	"./Project Board Feedback_1576214653535.mp4": "./src/assets/images/stockassets/Project Board Feedback_1576214653535.mp4",
	"./Upload Stock Graphic Page_1576214653535.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576214653535.png",
	"./Upload Stock Graphic Page_1576232878741.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576232878741.png",
	"./Upload Stock Graphic Page_1576233247908.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576233247908.png",
	"./Upload Stock Graphic Page_1576233775994.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576233775994.png",
	"./Upload Stock Graphic Page_1576234180264.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576234180264.png",
	"./Upload Stock Graphic Page_1576234391843.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576234391843.png",
	"./Upload Stock Graphic Page_1576243035263.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576243035263.png",
	"./Upload Stock Graphic Page_1576505740034.png": "./src/assets/images/stockassets/Upload Stock Graphic Page_1576505740034.png",
	"./brad316_1596517957311.png": "./src/assets/images/stockassets/brad316_1596517957311.png",
	"./jenniifar26_1596517957311.png": "./src/assets/images/stockassets/jenniifar26_1596517957311.png",
	"./maintence_1576243035263.jpg": "./src/assets/images/stockassets/maintence_1576243035263.jpg",
	"./tasklist_1576143425896.png": "./src/assets/images/stockassets/tasklist_1576143425896.png",
	"./tasklist_1576143602810.png": "./src/assets/images/stockassets/tasklist_1576143602810.png",
	"./tasklist_1576143827062.png": "./src/assets/images/stockassets/tasklist_1576143827062.png",
	"./tasklist_1576144014933.png": "./src/assets/images/stockassets/tasklist_1576144014933.png",
	"./tasklist_1576145563104.png": "./src/assets/images/stockassets/tasklist_1576145563104.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/stockassets sync recursive ^\\.\\/.*$";